<template>
  <div class="container-fluid">
    <div class="m-2">
      <div class="alert alert-primary">
        <div class="h4 text-center">
          <linkto :link="'/types'"/>
          Új típus rögzítés
        </div>
      </div>
    </div>
  	<div class="row d-flex justify-content-center">
  		<div class="col-12">
  			<div class="row d-flex justify-content-center align-items-center">
  				<typedata
  					:change="false"
  				>
  				</typedata>
  			</div>
  		</div>
  	</div>
  </div>
</template>

<script>
import typedata from './type_data'
export default {
  name: 'new_type',
  components: {
  	typedata
  }
  
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/types/new_type.vue